module.exports = ".question-wrapper {\n  margin-top: 23px;\n  border-top: 1px solid #c2c2c2; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.scss
// module id = ./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.scss
// module chunks = 0